import { Component, Input, OnInit } from '@angular/core';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { Store } from '@ngrx/store';
import { LineInterface } from '../../../../lines/models/line.interface';
import { UpdateMission } from '../../../store/actions/mission.actions';

@Component({
    selector: 'app-cancel-loss-steal',
    templateUrl: './cancel-loss-steal.component.html',
    styleUrls: ['./cancel-loss-steal.component.css'],
    standalone: false
})
export class CancelLossStealComponent implements OnInit {

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  formSubmitted: boolean;

  constructor(private store: Store<any>) { }

  ngOnInit() {
    this.formSubmitted = false;
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  confirmation() {
    if (this.formSubmitted === false) {
      this.formSubmitted = true;
      this.store.dispatch(new UpdateMission(
          {
            phoneNumber: this.line.phoneNumber
          },
          this.procedureCode
      ));
    }
  }

}
